/**
 * 统一布局组件 - 带侧边栏
 * 用于所有需要登录的页面
 */

import { AppSidebar } from "@/components/AppSidebar";
import { SidebarInset, SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";
import { Menu } from "lucide-react";
import type React from "react";

interface LayoutWithSidebarProps {
  children: React.ReactNode;
  title?: string;
}

export function LayoutWithSidebar({
  children,
  title
}: LayoutWithSidebarProps) {
  return (
    <SidebarProvider>
      <AppSidebar variant="inset" />
      <SidebarInset>
        {/* 始终显示侧边栏触发按钮和标题 - 移动端优化 */}
        <div className="flex h-14 sm:h-12 shrink-0 items-center gap-2 border-b bg-white dark:bg-gray-950 px-3 sm:px-4">
          {/* 优化的侧边栏触发按钮 */}
          <SidebarTrigger className="-ml-1 touch-target group" />

          {/* 移动端提示文字 */}
          <div className="sm:hidden flex items-center gap-2 ml-1">
            <div className="flex items-center gap-1.5 px-2 py-1 bg-blue-50 dark:bg-blue-950 rounded-md border border-blue-200 dark:border-blue-800">
              <Menu className="h-4 w-4 text-blue-600 dark:text-blue-400" />
              <span className="text-xs font-medium text-blue-600 dark:text-blue-400">菜单</span>
            </div>
          </div>

          {/* 页面标题 */}
          {title && (
            <h1 className="text-base sm:text-base font-medium truncate flex-1">
              {title}
            </h1>
          )}
        </div>

        <div className="flex flex-1 flex-col">
          <div className="flex-1">
            {children}
          </div>
          {/* 备案信息 - 移动端优化 */}
          <footer className="mt-auto py-4 sm:py-6 text-center text-xs sm:text-sm text-gray-500 border-t safe-bottom">
            <div className="space-y-0.5 sm:space-y-1 px-3 sm:px-4">
              <p className="text-xs sm:text-sm">网站域名：yikaihui.com</p>
              <p className="text-xs sm:text-sm">
                <a
                  href="https://beian.miit.gov.cn/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-gray-700 transition-colors"
                >
                  京ICP备17037227号-1
                </a>
              </p>
            </div>
          </footer>
        </div>
      </SidebarInset>
    </SidebarProvider>
  );
}

